module.exports = __webpack_public_path__ + "static/media/seguradora_axa.03fd62d6.png";